import { getOpenAddHits } from "@/api/publicApi";

// export async function  addHits (id) { 
//     const { code, data } = await getOpenAddHits(id); 
// }

// 通用点击
export function addHits (id) { 
  getOpenAddHits(id); 
} 


// WEBPACK FOOTER //
// ./src/util/publicHits.js